/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer } from 'dtp-react-components';
import FiltroRelatorio from './FiltroRelatorio';
import Relatorio from './Relatorio';
import {
  buscaDestinatarios,
  doGet,
  doGetPaginado,
} from '../../utils/requests';
import { manterApenasFiltro } from '../../utils/helpers';
import {
  Button,
} from '../../components/index';
import * as listUtils from '../../utils/listsSelect';
import User from '../../domain/User';

class TelaRelatorioPagamentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaResultados: [],
      listaResultadosFormatados: [],
      colunasRelatorio: [],
      nomeRelatorio: '',
      filtrosAtuais: {},
      dataFormatOptions: {},
      dataHistory: [],
      nomeRelatorioHistory: [],
      colunasHistory: [],
      dataFormatHistory: [],
      isUsuarioLogadoOrgaoCentralizador: 0,
    };
  }

  componentDidMount() {
    manterApenasFiltro('');
    // if (this.props.destinatarios.length === 0 && this.isRgps()) {
    if (this.props.destinatarios.length === 0 && this.isPapelHabilitadoParaUso()) {
      buscaDestinatarios(this.tratarErro);
    }
    if (!this.isPapelHabilitadoParaUso()) {
      this.buscarParticipantePeloCnpjLogado();
    }
  }

  colunasRelatorioPagamento = [
    'Ano',
    'Mês',
    'Participante 1 (*)',
    'Participante 2 (*)',
    'CNPJ do RPPS',
    'Saldo Estoque',
    'Part. Saldo Estoque a Receber',
    'Valor Parcela Estoque',
    'Valor Saldo Fluxo',
    'Part. Saldo Fluxo',
    'Valor Saldo Fluxo Acumulado',
    'Part. Saldo Fluxo Acumulado',
    'Valor Compensação',
    'Part. Valor Compensação',
    'Valor Total Bloqueado Competência Anterior (*)',
    'Valor Total Desbloqueado Competência (*)',
    'Valor a receber',
    'Valor Bloqueado (*)',
    'Valor Total Rejeitado Competência Anterior',
    'Participante Rejeitado Competência Anterior',
  ]

  colunasRelatorioParticipantes = [
    'Ano',
    'Mês',
    'Solicitante (*)',
    'Destinatário (*)',
    'CNPJ RPPS',
    'Valor Estoque Bruto',
    'Requerimentos de Estoque (*)',
    'Valor Glosa Estoque (*)',
    'Valor Estoque Liquido',
    'Requerimentos Concedidos (*)',
    'Valor Fluxo Acumulado Bruto',
    'Valor 13º Fluxo Acumulado',
    'Valor Glosa Fluxo Acumulado (*)',
    'Valor Fluxo Acumulado Liquido',
    'Requerimentos de Fluxo (*)',
    'Valor Fluxo Bruto',
    'Valor 13º Fluxo',
    'Valor Glosa Fluxo (*)',
    'Valor Fluxo Liquido',
    'Bloqueado S/N',
    'Valor Total Líquido',
  ]

  colunasRelatorioRequerimentosRGPS = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Benefício',
    'Nome Beneficiário',
    'Valor Estoque',
    'Valor 13º Estoque',
    'Valor Fluxo',
    'Valor 13º Fluxo',
    'Valor Fluxo Acumulado',
    'Valor 13º Fluxo Acumulado',
    'Valor Pro Rata Mensal',
    'Data Início Fluxo Acumulado',
    'Data Fim Fluxo Acumulado',
    'Data Início Estoque',
    'Data Fim Estoque',
    'Valor Total Estoque',
    'Valor Total Fluxo',
    'Valor Total Fluxo Acumulado',
    'Tipo Segregação Destinatário',
  ]

  colunasRelatorioRequerimentos = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Benefício',
    'Nome Beneficiário',
    'Valor Estoque',
    'Valor 13º Estoque',
    'Valor Fluxo',
    'Valor 13º Fluxo',
    'Valor Fluxo Acumulado',
    'Valor 13º Fluxo Acumulado',
    'Valor Pro Rata Mensal',
    'Data Início Fluxo Acumulado',
    'Data Fim Fluxo Acumulado',
    'Data Início Estoque',
    'Data Fim Estoque',
    'Valor Total Estoque',
    'Valor Total Fluxo',
    'Valor Total Fluxo Acumulado',
    'Tipo Segregação Solicitante',
    'Tipo Segregação Destinatário',
  ]

  colunasRelatorioRequerimentosRPPU = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Benefício',
    'Nome Beneficiário',
    'Valor Estoque',
    'Valor 13º Estoque',
    'Valor Fluxo',
    'Valor 13º Fluxo',
    'Valor Fluxo Acumulado',
    'Valor 13º Fluxo Acumulado',
    'Valor Pro Rata Mensal',
    'Data Início Fluxo Acumulado',
    'Data Fim Fluxo Acumulado',
    'Data Início Estoque',
    'Data Fim Estoque',
    'Valor Total Estoque',
    'Valor Total Fluxo',
    'Valor Total Fluxo Acumulado',
    'Orgão Origem Solicitante',
    'Orgão Origem Destinatário',
    'Tipo Segregação Solicitante',
    'Tipo Segregação Destinatário',
  ]

  colunasRelatorioRequerimentosEstoque = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Beneficio',
    'Nome Beneficiário',
    'Valor Estoque',
    'Valor 13º Estoque',
    'Valor Pro Rata Mensal',
    'Data Início Estoque',
    'Data Fim Estoque',
    'Valor Total Estoque',
    'Estado Pagamento Estoque',
  ]

  colunasRelatorioRequerimentosEstoqueRPPU = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Beneficio',
    'Nome Beneficiário',
    'Valor Estoque',
    'Valor 13º Estoque',
    'Valor Pro Rata Mensal',
    'Data Início Estoque',
    'Data Fim Estoque',
    'Valor Total Estoque',
    'Estado Pagamento Estoque',
    'Orgão Origem Solicitante',
    'Orgão Origem Destinatário',
  ]

  colunasRelatorioRequerimentosConcedido = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Beneficio',
    'Nome Beneficiário',
    'Valor Estoque',
    'Valor 13º Estoque',
    'Valor Fluxo',
    'Valor 13º Fluxo',
    'Valor Fluxo Acumulado',
    'Valor 13º Fluxo Acumulado',
    'Valor Pro Rata Mensal',
    'Data Início Fluxo Acumulado',
    'Data Fim Fluxo Acumulado',
    'Valor Total Estoque',
    'Valor Total Fluxo',
    'Valor Total Fluxo Acumulado',
  ]

  colunasRelatorioRequerimentosConcedidoRPPU = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Beneficio',
    'Nome Beneficiário',
    'Valor Estoque',
    'Valor 13º Estoque',
    'Valor Fluxo',
    'Valor 13º Fluxo',
    'Valor Fluxo Acumulado',
    'Valor 13º Fluxo Acumulado',
    'Valor Pro Rata Mensal',
    'Data Início Fluxo Acumulado',
    'Data Fim Fluxo Acumulado',
    'Valor Total Estoque',
    'Valor Total Fluxo',
    'Valor Total Fluxo Acumulado',
    'Orgão Origem Solicitante',
    'Orgão Origem Destinatário',
  ]

  colunasRelatorioRequerimentosFluxo = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Beneficio',
    'Nome Beneficiário',
    'Valor Fluxo',
    'Valor 13º Fluxo',
    'Valor Pro Rata Mensal',
    'Valor Total Fluxo',
  ]

  colunasRelatorioRequerimentosFluxoRPPU = [
    '#',
    'Protocolo',
    'Mês',
    'Ano',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matricula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Beneficio',
    'Nome Beneficiário',
    'Valor Fluxo',
    'Valor 13º Fluxo',
    'Valor Pro Rata Mensal',
    'Valor Total Fluxo',
    'Orgão Origem Solicitante',
    'Orgão Origem Destinatário',
  ]

  colunasRelatorioGlosaFluxo = [
    'Protocolo',
    'Ano',
    'Mês',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matrícula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Benefício',
    'Nome Beneficiário',
    'Glosa Fluxo',
    'Motivo Glosa',
    'Data Início Glosa Fluxo',
    'Data Fim Glosa Fluxo',
  ]

  colunasRelatorioGlosaPassivo = [
    'Protocolo',
    'Ano',
    'Mês',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matrícula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Benefício',
    'Nome Beneficiário',
    'Glosa Fluxo Acumulado',
    'Motivo Glosa',
  ]

  colunasRelatorioGlosaEstoque = [
    'Protocolo',
    'Ano',
    'Mês',
    'Solicitante',
    'Destinatário',
    'CNPJ RPPS',
    'NIT',
    'CPF',
    'Matrícula',
    'Tipo Requerimento',
    'Tipo Aposentadoria',
    'Número Benefício',
    'Nome Beneficiário',
    'Valor Glosa Estoque',
    'Motivo Glosa',
    'Glosas de Dação',
  ]

  colunasRelatorioGlosaDacao = [
    'Solicitante',
    'Destinatário',
    'Ano Pagamento Glosa',
    'Mês Pagamento Glosa',
    'Tipo Glosa',
    'Valor Glosa',
    'Data Inclusão',
    'Motivo Glosa',
    'Observação',
  ]

  colunasRelatorioBloqueios = [
    'Solicitante',
    'Destinatário',
    'Ano Pagamento',
    'Mês Pagamento',
    'Valor Bloqueado',
    'Motivo',
    'Ind. Pagamento',
    'Competência Pagamento',
    'Valor Reajustado',
  ]

  traduzirMotivoBloqueio = idMotivo => (
    listUtils.getObject(listUtils.motivosBloqueio, idMotivo).label
  );

  handlePesquisar = (valoresFiltro) => {
    const d1 = valoresFiltro.competenciaInicial;
    const d2 = valoresFiltro.competenciaFinal;

    if (d1.length !== 6 || d2.length !== 6) {
      this.addMessage('Competências devem ser no formato MM-AAAA');
      return;
    }

    const d1Ano = parseInt(d1.substring(2, 6), 10);
    const d2Ano = parseInt(d2.substring(2, 6), 10);
    const d1Mes = parseInt(d1.substring(0, 2), 10);
    const d2Mes = parseInt(d2.substring(0, 2), 10);

    if (d1Mes > 12) {
      this.addMessage('Competência inicial inválida.');
      return;
    }

    if (d2Mes > 12) {
      this.addMessage('Competência final inválida.');
      return;
    }

    if ((d2Ano < d1Ano) || (d2Ano === d1Ano && d2Mes < d1Mes)) {
      this.addMessage('Competência final deve ser maior ou igual a competência inicial');
      return;
    }
    let months = (d2Ano - d1Ano) * 12;
    months -= d1Mes;
    months += d2Mes;
    if (months > 12 || months < 0) {
      this.addMessage('Competência final deve ser no máximo 12 meses maior que a competência inicial');
      return;
    }

    /* if (!valoresFiltro['destinatario-rpps']) {
      this.addMessage('Escolha um destinatário para a pesquisa.');
      return;
    } */

    this.setState({
      filtrosAtuais: valoresFiltro,
    }, () => this.executaConsulta(null, 'ajuste-contas'));
  }

  isRgps = () => this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']);
  isAuditor = () => this.props.auth.checkPermission(['auditar-comprev']);
  isAnalistaDtp = () => this.props.auth.checkPermission(['analisar-negocio-dtpv']);
  isAnalistaRgpsConsulta = () => this.props.auth.checkPermission(['consultar-compensacao-rgps']);
  isAnalistaSprev = () => this.props.auth.checkPermission(['analisar-negocio-sprev']);

  isPapelHabilitadoParaUso = () => (
    this.isRgps() || this.isAuditor() || this.isAnalistaDtp() || this.isAnalistaRgpsConsulta() || this.isAnalistaSprev()
  );

  defineModalidadeRequerimento = (tipo) => {
    if (tipo === 'estoque') {
      return 1;
    } else if (tipo === 'concedidos') {
      return 2;
    } else if (tipo === 'fluxo') {
      return 3;
    }
    return null;
  }

  defineModalidadeGlosa = (tipo) => {
    if (tipo === 'fluxo' || tipo === 'dacao') {
      return 1;
    } else if (tipo === 'estoque') {
      return 2;
    } else if (tipo === 'passivo') {
      return 3;
    }
    return null;
  }

  defineCompetenciaFiltro = (row) => {
    let mes = row.mesCompetencia ? row.mesCompetencia : row.mesCompetenciaPagamento;
    const ano = row.anoCompetencia ? row.anoCompetencia : row.anoCompetenciaPagamento;
    mes = mes.toString().length === 1
      ? `0${mes}` : mes;
    return ano.toString() + mes.toString();
  }

  defineNivelFiltro = (relatorio) => {
    // if (!this.isRgps()) {
    if (!this.isPapelHabilitadoParaUso()) {
      return 4;
    } else if (relatorio === 'ajuste-contas') {
      if (this.state.filtrosAtuais['destinatario-rpps']) {
        return 4;
      } else if (this.state.filtrosAtuais.ente) {
        return 4;
      } else if (this.state.filtrosAtuais.aps) {
        return 3;
      } else if (this.state.filtrosAtuais.gex) {
        return 2;
      } else if (this.state.filtrosAtuais.superintendencia) {
        return 1;
      }
    } else {
      return 4;
    }
    return 0;
  }

  handleSuccessBuscaPeloCnpjLogado = (response) => {
    if (response.data) {
      this.setState({
        isUsuarioLogadoOrgaoCentralizador: response.data.inOrgaoCentralizador,
      });
    }
  }

  handleErrorBuscaPeloCnpjLogado = () => (
    ''
  );

  buscarParticipantePeloCnpjLogado = () => {
    const usuarioLogado = new User(localStorage.getItem('jwt'));
    const cnpj = usuarioLogado.cnpjDoPapel();
    if (cnpj) {
      doGet(
        `participantes-compensacao/centralizador/${cnpj}`,
        this.handleSuccessBuscaPeloCnpjLogado,
        this.handleErrorBuscaPeloCnpjLogado,
      );
    }
  }

  recuperarCodigoParticipanteExibicao = (nomeParticipante) => {
    let retorno = '';
    if (nomeParticipante !== null && nomeParticipante !== '') {
      retorno = nomeParticipante.substring((nomeParticipante.lastIndexOf('-') + 1), nomeParticipante.length);
    }
    return retorno;
  }

  defineCodigoOutroParticipante = (parametros, relatorio, row) => {
    const novosParametros = parametros;
    // if (!this.isRgps()) {
    if (!this.isPapelHabilitadoParaUso()) {
      novosParametros.outroParticipante = '01000';
    } else if (relatorio === 'ajuste-contas') {
      if (this.state.filtrosAtuais['destinatario-rpps']) {
        novosParametros.outroParticipante = this.state.filtrosAtuais['destinatario-rpps'];
      } else if (this.state.filtrosAtuais.ente) {
        novosParametros.outroParticipante = this.state.filtrosAtuais.ente;
      } else if (this.state.filtrosAtuais.aps) {
        novosParametros.codigo = this.state.filtrosAtuais.aps;
      } else if (this.state.filtrosAtuais.gex) {
        novosParametros.codigo = this.state.filtrosAtuais.gex;
      } else if (this.state.filtrosAtuais.superintendencia) {
        novosParametros.codigo = this.state.filtrosAtuais.superintendencia;
      }
    } else if (relatorio === 'participantes' || relatorio === 'bloqueios') {
      // const participante1 = row.participante1 === 'RGPS' ? '01000' : row.participante1.split('-')[1];
      // novosParametros.outroParticipante = participante1 === '01000' ? row.participante2.split('-')[1] : participante1;
      const participante1 = row.participante1 === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.participante1);
      novosParametros.outroParticipante = participante1 === '01000' ? this.recuperarCodigoParticipanteExibicao(row.participante2) : participante1;
    } else {
      // const solicitante = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
      // novosParametros.outroParticipante = solicitante === '01000' ? row.destinatario.split('-')[1] : solicitante;
      const solicitante = row.solicitante === 'RGPS' ? '01000' : this.recuperarCodigoParticipanteExibicao(row.solicitante);
      novosParametros.outroParticipante = solicitante === '01000' ? this.recuperarCodigoParticipanteExibicao(row.destinatario) : solicitante;
    }

    // if ((relatorio === 'participantes') && !this.isRgps() && row.participante1 !== 'RGPS' && row.participante2 !== 'RGPS') {
    if ((relatorio === 'participantes') && !this.isPapelHabilitadoParaUso() && row.participante1 !== 'RGPS' && row.participante2 !== 'RGPS') {
      // const solicitante = row.participante1.split('-')[1];
      // const destinat = row.participante2.split('-')[1];
      // novosParametros.codigo = row.participante1.substring((row.participante1.lastIndexOf('-') + 1), row.participante1.length);
      // novosParametros.outroParticipante = row.participante2.substring((row.participante2.lastIndexOf('-') + 1), row.participante2.length);
      novosParametros.codigo = this.recuperarCodigoParticipanteExibicao(row.participante1);
      novosParametros.outroParticipante = this.recuperarCodigoParticipanteExibicao(row.participante2);
    }

    // if ((relatorio === 'requerimentos' || relatorio === 'glosa') && !this.isRgps() && row.solicitante !== 'RGPS' && row.destinatario !== 'RGPS') {
    if ((relatorio === 'requerimentos' || relatorio === 'glosa') && !this.isPapelHabilitadoParaUso() && row.solicitante !== 'RGPS' && row.destinatario !== 'RGPS') {
      /* const solicitante = row.solicitante.split('-')[1];
      const dest = row.destinatario.split('-')[1];
      novosParametros.codigo = solicitante.substring(solicitante.length - 5, solicitante.length);
      novosParametros.outroParticipante = dest.substring(dest.length - 5, dest.length); */
      novosParametros.codigo = this.recuperarCodigoParticipanteExibicao(row.solicitante);
      novosParametros.outroParticipante = this.recuperarCodigoParticipanteExibicao(row.destinatario);
    }

    if ((relatorio === 'bloqueios')) {
      if (row.participante1 === 'RGPS') {
        novosParametros.codigo = '01000';
        // const dest = row.participante2.split('-')[1];
        // novosParametros.outroParticipante = dest.substring(dest.length - 5, dest.length);
        novosParametros.outroParticipante = this.recuperarCodigoParticipanteExibicao(row.participante2);
      } else {
        // const solicitante = row.participante1.split('-')[1];
        // const dest = row.participante2.split('-')[1];
        // novosParametros.codigo = solicitante.substring(solicitante.length - 5, solicitante.length);
        // novosParametros.outroParticipante = dest.substring(dest.length - 5, dest.length);
        novosParametros.codigo = this.recuperarCodigoParticipanteExibicao(row.participante1);
        novosParametros.outroParticipante = this.recuperarCodigoParticipanteExibicao(row.participante2);
      }
    }

    return novosParametros;
  }

  defineTipoBloqueio = (relatorio) => {
    if (relatorio === 'bloqueios') {
      return 1;
    } else if (relatorio === 'desbloqueios') {
      return 2;
    } else if (relatorio === 'bloqueios-anterior') {
      return 3;
    }
    return null;
  }

  defineModalidadeRelacao = (row) => {
    // if (this.isRgps()) {
    if (this.isPapelHabilitadoParaUso()) {
      return row.solicitante === 'RGPS' ? 'solicitante' : 'destinatario';
    }
    return row.destinatario === 'RGPS' ? 'solicitante' : 'destinatario';
  }

  executaConsulta = (row, relatorio, filho) => {
    let urlRelatorio = null;
    let paginado = false;
    let parametros = {
      competenciaInicial: row ? this.defineCompetenciaFiltro(row) :
        this.state.filtrosAtuais.competenciaInicial.substring(2, 6) +
        this.state.filtrosAtuais.competenciaInicial.substring(0, 2),
      competenciaFinal: row ? this.defineCompetenciaFiltro(row) :
        this.state.filtrosAtuais.competenciaFinal.substring(2, 6) +
        this.state.filtrosAtuais.competenciaFinal.substring(0, 2),
      nivel: this.defineNivelFiltro(relatorio),
    };

    parametros = this.defineCodigoOutroParticipante(parametros, relatorio, row);

    if (relatorio === 'ajuste-contas') {
      urlRelatorio = 'filtro-ajuste-contas';
    } else if (relatorio === 'participantes') {
      urlRelatorio = 'filtro-calculo-participante-pagamento';
    } else if (relatorio === 'requerimentos') {
      const isUsuarioLogadoRGPS = User.logged().isRGPS();
      paginado = true;
      parametros.modalidadeRelacao = this.defineModalidadeRelacao(row);
      const { isUsuarioLogadoOrgaoCentralizador } = { ...this.state };
      parametros.usuarioOrgaoCentralizador = isUsuarioLogadoOrgaoCentralizador;
      parametros.usuarioLogadoRGPS = isUsuarioLogadoRGPS ? 1 : 0;
      urlRelatorio = 'filtro-calculo-requerimento-pagamento';
      if (filho) {
        parametros.modalidadeTotalizador = this.defineModalidadeRequerimento(filho);
        parametros.usuarioLogadoOrgaoCentralizador = this.state.isUsuarioLogadoOrgaoCentralizador;
        urlRelatorio += '-totalizador';
      }
    } else if (relatorio === 'glosa') {
      if (filho === 'dacao') {
        // if (!this.isRgps() && row.solicitante !== 'RGPS' && row.destinatario !== 'RGPS') {
        if (!this.isPapelHabilitadoParaUso() && row.solicitante !== 'RGPS' && row.destinatario !== 'RGPS') {
          // const solicitante = // row.solicitante.split('-')[1];
          // const dest = // row.destinatario.split('-')[1];
          parametros.codigo = this.recuperarCodigoParticipanteExibicao(row.solicitante); // solicitante.substring(solicitante.length - 5, solicitante.length);
          parametros.outroParticipante = this.recuperarCodigoParticipanteExibicao(row.destinatario); // dest.substring(dest.length - 5, dest.length);
          parametros = {
            codigo: parametros.codigo,
            competencia: parametros.competenciaInicial,
            outroParticipante: parametros.outroParticipante,
            modalidadeRelacao: this.defineModalidadeRelacao(row),
            modalidadeGlosa: this.defineModalidadeGlosa(filho),
          };
        } else {
          parametros = {
            competencia: parametros.competenciaInicial,
            outroParticipante: parametros.outroParticipante,
            modalidadeRelacao: this.defineModalidadeRelacao(row),
            modalidadeGlosa: this.defineModalidadeGlosa(filho),
          };
        }
        urlRelatorio = 'filtro-glosas';
      } else {
        parametros.modalidadeRelacao = this.defineModalidadeRelacao(row);
        parametros.modalidadeGlosa = this.defineModalidadeGlosa(filho);
        urlRelatorio = 'filtro-glosa-requerimento-competencia';
      }
    } else if (relatorio === 'bloqueios') {
      parametros = {
        codigo: parametros.codigo,
        outroParticipante: parametros.outroParticipante,
        situacaoPagamento: filho === 'desbloqueios' ? 1 : 0,
        tipoConsulta: this.defineTipoBloqueio(filho),
        competPagBloqueados: this.defineCompetenciaFiltro(row),
      };
      urlRelatorio = 'filtro-lista-valores-bloqueados';
    }

    this.setState({
      dataHistory: [...this.state.dataHistory, this.state.listaResultados],
      nomeRelatorioHistory: [...this.state.nomeRelatorioHistory, this.state.nomeRelatorio],
      colunasHistory: [...this.state.colunasHistory, this.state.colunasRelatorio],
      dataFormatHistory: [...this.state.dataFormatHistory, this.state.dataFormatOptions],
    }, () => this.preparaRequest(urlRelatorio, relatorio, filho, parametros, paginado));
  };

  preparaRequest = (urlRelatorio, relatorio, filho, parametros, paginado) => {
    if (paginado) {
      doGetPaginado(`relatorios-pagamentos/${urlRelatorio}`, this.tratarSucesso(relatorio, filho), this.tratarErro, parametros, 10000);
    } else {
      doGet(`relatorios-pagamentos/${urlRelatorio}`, this.tratarSucesso(relatorio, filho), this.tratarErro, parametros);
    }
  }

  escolherHeaderRelatorioRequerimentos = () => {
    let retorno = this.colunasRelatorioRequerimentos;
    if (User.logged().isRGPS()) {
      retorno = this.colunasRelatorioRequerimentosRGPS;
    }
    return retorno;
  }

  tratarSucesso = (relatorio, filho) => (response) => {
    if (response.data !== '') {
      const { isUsuarioLogadoOrgaoCentralizador } = { ...this.state };
      let novoNome = '';
      let novasColunas = [];
      let dataFormatOptions = {};
      let colunasFormatar = [];
      if (relatorio === 'ajuste-contas') {
        novoNome = 'Relatório de Ajuste de Contas';
        novasColunas = this.colunasRelatorioPagamento;
        dataFormatOptions = this.pagamentosDataFormatOptions;
        colunasFormatar = this.pagamentosColunasFormatar;
      } else if (relatorio === 'participantes') {
        novoNome = 'Relatório de Pagamentos por Participantes';
        novasColunas = this.colunasRelatorioParticipantes;
        dataFormatOptions = this.participantesDataFormatOptions;
        colunasFormatar = this.participantesColunasFormatar;
      } else if (relatorio === 'requerimentos') {
        response.data = response.data.map((row, i) => ({ seq: i + 1, ...row }));
        novoNome = 'Relatório de Pagamentos por Requerimentos';
        novasColunas = (isUsuarioLogadoOrgaoCentralizador === 1) ?
          this.colunasRelatorioRequerimentosRPPU : this.escolherHeaderRelatorioRequerimentos();
        dataFormatOptions = this.requerimentosDataFormatOptions;
        colunasFormatar = this.requerimentosColunasFormatar;
        if (filho === 'estoque') {
          novoNome += ' de Estoque';
          // novasColunas = this.colunasRelatorioRequerimentosEstoque;
          novasColunas = (isUsuarioLogadoOrgaoCentralizador === 1) ?
            this.colunasRelatorioRequerimentosEstoqueRPPU :
            this.colunasRelatorioRequerimentosEstoque;
          dataFormatOptions = this.requerimentosEstoqueDataFormatOptions;
          colunasFormatar = this.requerimentosEstoqueColunasFormatar;
        } else if (filho === 'concedidos') {
          novoNome += ' Concedidos';
          // novasColunas = this.colunasRelatorioRequerimentosConcedido;
          novasColunas = (isUsuarioLogadoOrgaoCentralizador === 1) ?
            this.colunasRelatorioRequerimentosConcedidoRPPU :
            this.colunasRelatorioRequerimentosConcedido;
          dataFormatOptions = this.requerimentosConcedidosDataFormatOptions;
          colunasFormatar = this.requerimentosConcedidosColunasFormatar;
        } else if (filho === 'fluxo') {
          novoNome += ' de Fluxo';
          // novasColunas = this.colunasRelatorioRequerimentosFluxo;
          novasColunas = (isUsuarioLogadoOrgaoCentralizador === 1) ?
            this.colunasRelatorioRequerimentosFluxoRPPU :
            this.colunasRelatorioRequerimentosFluxo;
          dataFormatOptions = this.requerimentosFluxoDataFormatOptions;
          colunasFormatar = this.requerimentosFluxoColunasFormatar;
        }
      } else if (relatorio === 'glosa') {
        novoNome = 'Relatório de Glosas';
        if (filho === 'fluxo') {
          novoNome += ' de Fluxo';
          novasColunas = this.colunasRelatorioGlosaFluxo;
          dataFormatOptions = this.glosaDataFormatOptions;
          colunasFormatar = this.glosaColunasFormatar;
        } else if (filho === 'passivo') {
          novoNome += ' de Fluxo Acumulado';
          novasColunas = this.colunasRelatorioGlosaPassivo;
          dataFormatOptions = this.glosaDataFormatOptions;
          colunasFormatar = this.glosaColunasFormatar;
        } else if (filho === 'estoque') {
          novoNome += ' de Estoque';
          novasColunas = this.colunasRelatorioGlosaEstoque;
          dataFormatOptions = this.glosaEstoqueDataFormatOptions;
          colunasFormatar = this.glosaEstoqueColunasFormatar;
        } else if (filho === 'dacao') {
          novoNome += ' de Dação';
          novasColunas = this.colunasRelatorioGlosaDacao;
          dataFormatOptions = this.glosaDacaoDataFormatOptions;
          colunasFormatar = this.glosaDacaoColunasFormatar;
        }
      } else if (relatorio === 'bloqueios') {
        novoNome = 'Relatório de Bloqueios';
        novasColunas = this.colunasRelatorioBloqueios;
        dataFormatOptions = this.bloqueiosDataFormatOptions;
        colunasFormatar = this.bloqueiosColunasFormatar;
      }

      const dadosFormatados = this.prepararColunas(response.data, colunasFormatar);
      const listaDadosFormatados = dadosFormatados.map((item) => {
        const itemFormatado = item;
        if ((item.orgaoOrigemDestinatario === null || item.orgaoOrigemDestinatario === undefined)) {
          itemFormatado.orgaoOrigemDestinatario = '';
        }
        if ((item.orgaoOrigemSolicitante === undefined || item.orgaoOrigemSolicitante === null)) {
          itemFormatado.orgaoOrigemSolicitante = '';
        }
        if ((item.statusPagamentoEstoque === undefined || item.statusPagamentoEstoque === null)) {
          itemFormatado.statusPagamentoEstoque = '';
        }
        if ((item.ordem === 1)) {
          itemFormatado.ordem = '';
        }
        return itemFormatado;
      });

      this.setState({
        listaResultados: response.data,
        listaResultadosFormatados: listaDadosFormatados,
        colunasRelatorio: novasColunas,
        nomeRelatorio: novoNome,
        dataFormatOptions,
      });
    }
  }

  prepararColunas = (data, colunas) => {
    const dados = data.map((item) => {
      const linha = Object.assign({}, item);
      colunas.forEach((c) => {
        const key = Object.keys(item)[c.index];
        const coluna = item[key];
        const colunaFormatada = this.formatarColuna(coluna, c.tipo);
        linha[key] = colunaFormatada;
      });

      return linha;
    });

    return dados;
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.addMessage('Nenhum resultado encontrado para o filtro informado.');
        } else {
          this.addMessage(`${data.mensagem}`);
        }
      } else {
        this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
      }
    }
  };

  handleVoltar = () => {
    const data = this.state.dataHistory.pop();
    this.setState({
      listaResultados: data,
      listaResultadosFormatados: data,
      colunasRelatorio: this.state.colunasHistory.pop(),
      nomeRelatorio: this.state.nomeRelatorioHistory.pop(),
      dataFormatOptions: this.state.dataFormatHistory.pop(),
    });
  }

  // verificaTipoSegregacao = (valor) => {
  //   let retorno = '';
  //   if (valor && valor !== '' && valor !== null) {
  //     if (valor === 1) {
  //       retorno = 'Fundo Financeiro (Repartição)';
  //     }
  //     if (valor === 2) {
  //       retorno = 'Fundo Previdenciário (Capitalização)';
  //     }
  //   }
  //   return retorno;
  // }

  montaColuna = (relatorio, filho, tipo) => (cell, row) => {
    let valor = cell;

    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'moeda') {
      valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).formatToParts(cell).map(({ type, value }) => {
        switch (type) {
          case 'currency': return '';
          default: return value;
        }
      }).reduce((string, part) => string + part);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else if (tipo === 'booleano') {
      valor = cell === 1 ? 'S' : 'N';
    } else if (tipo === 'protocolo') {
      valor = `'${cell}`;
    } else if (tipo === 'motivoBloqueio') {
      if (cell) {
        valor = this.traduzirMotivoBloqueio(cell);
      } else {
        valor = '';
      }
    }
    // else if (tipo === 'tipoSegregacao') {
    //   valor = this.verificaTipoSegregacao(valor);
    // }

    if (tipo === 'botao') {
      return (
        <React.Fragment>
          <Button
            hint="Glosas de Dação"
            onClick={() => this.executaConsulta(row, relatorio, filho)}
            icon="ico-clipboard-list"
            mini
          />
        </React.Fragment>
      );
    } else if (relatorio) {
      return (
        <React.Fragment>
          {
          relatorio ? (
            <a
              href="#"
              onClick={() => this.executaConsulta(row, relatorio, filho)}
            >{valor}
            </a>
          ) : (
          valor
          )
        }
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {valor}
      </React.Fragment>
    );
  }

  formatarColuna = (cell, tipo) => {
    let valor = cell;

    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'moeda') {
      valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).formatToParts(cell).map(({ type, value }) => {
        switch (type) {
          case 'currency': return '';
          default: return value;
        }
      }).reduce((string, part) => string + part);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else if (tipo === 'booleano') {
      valor = cell === 1 ? 'S' : 'N';
    } else if (tipo === 'protocolo') {
      valor = `'${cell}`;
    } else if (tipo === 'motivoBloqueio') {
      if (cell) {
        valor = this.traduzirMotivoBloqueio(cell);
      } else {
        valor = '';
      }
    } // else if (tipo === 'tipoSegregacao') {
    //   valor = this.verificaTipoSegregacao(valor);
    // }
    return valor.trim();
  }

  pagamentosColunasFormatar = [
    { index: 4, tipo: 'cnpj' },
    { index: 5, tipo: 'moeda' },
    { index: 7, tipo: 'moeda' },
    { index: 8, tipo: 'moeda' },
    { index: 10, tipo: 'moeda' },
    { index: 12, tipo: 'moeda' },
    { index: 14, tipo: 'moeda' },
    { index: 15, tipo: 'moeda' },
    { index: 16, tipo: 'moeda' },
    { index: 17, tipo: 'moeda' },
    { index: 18, tipo: 'moeda' },
  ];

  pagamentosDataFormatOptions = {
    2: this.montaColuna('participantes'),
    3: this.montaColuna('participantes'),
    4: this.montaColuna(null, null, 'cnpj'),
    5: this.montaColuna(null, null, 'moeda'),
    7: this.montaColuna(null, null, 'moeda'),
    8: this.montaColuna(null, null, 'moeda'),
    10: this.montaColuna(null, null, 'moeda'),
    12: this.montaColuna(null, null, 'moeda'),
    14: this.montaColuna('bloqueios', 'bloqueios-anterior', 'moeda'),
    15: this.montaColuna('bloqueios', 'desbloqueios', 'moeda'),
    16: this.montaColuna(null, null, 'moeda'),
    17: this.montaColuna('bloqueios', 'bloqueios', 'moeda'),
    18: this.montaColuna(null, null, 'moeda'),
  }

  participantesColunasFormatar = [
    { index: 4, tipo: 'cnpj' },
    { index: 5, tipo: 'moeda' },
    { index: 6, tipo: 'numero' },
    { index: 7, tipo: 'moeda' },
    { index: 8, tipo: 'moeda' },
    { index: 9, tipo: 'numero' },
    { index: 10, tipo: 'moeda' },
    { index: 11, tipo: 'moeda' },
    { index: 12, tipo: 'moeda' },
    { index: 13, tipo: 'moeda' },
    { index: 14, tipo: 'numero' },
    { index: 15, tipo: 'moeda' },
    { index: 16, tipo: 'moeda' },
    { index: 17, tipo: 'moeda' },
    { index: 18, tipo: 'moeda' },
    { index: 19, tipo: 'booleano' },
    { index: 20, tipo: 'moeda' },
  ];

  participantesDataFormatOptions = {
    2: this.montaColuna('requerimentos'),
    3: this.montaColuna('requerimentos'),
    4: this.montaColuna(null, null, 'cnpj'),
    5: this.montaColuna(null, null, 'moeda'),
    6: this.montaColuna('requerimentos', 'estoque', 'numero'),
    7: this.montaColuna('glosa', 'estoque', 'moeda'),
    8: this.montaColuna(null, null, 'moeda'),
    9: this.montaColuna('requerimentos', 'concedidos', 'numero'),
    10: this.montaColuna(null, null, 'moeda'),
    11: this.montaColuna(null, null, 'moeda'),
    12: this.montaColuna('glosa', 'passivo', 'moeda'),
    13: this.montaColuna(null, null, 'moeda'),
    14: this.montaColuna('requerimentos', 'fluxo', 'numero'),
    15: this.montaColuna(null, null, 'moeda'),
    16: this.montaColuna(null, null, 'moeda'),
    17: this.montaColuna('glosa', 'fluxo', 'moeda'),
    18: this.montaColuna(null, null, 'moeda'),
    19: this.montaColuna(null, null, 'booleano'),
    20: this.montaColuna(null, null, 'moeda'),
  }

  requerimentosColunasFormatar = [
    { index: 6, tipo: 'cnpj' },
    { index: 8, tipo: 'cpf' },
    { index: 14, tipo: 'moeda' },
    { index: 15, tipo: 'moeda' },
    { index: 16, tipo: 'moeda' },
    { index: 17, tipo: 'moeda' },
    { index: 18, tipo: 'moeda' },
    { index: 19, tipo: 'moeda' },
    { index: 20, tipo: 'moeda' },
    { index: 25, tipo: 'moeda' },
    { index: 26, tipo: 'moeda' },
    { index: 27, tipo: 'moeda' },
  ];

  requerimentosDataFormatOptions = {
    6: this.montaColuna(null, null, 'cnpj'),
    8: this.montaColuna(null, null, 'cpf'),
    14: this.montaColuna(null, null, 'moeda'),
    15: this.montaColuna(null, null, 'moeda'),
    16: this.montaColuna(null, null, 'moeda'),
    17: this.montaColuna(null, null, 'moeda'),
    18: this.montaColuna(null, null, 'moeda'),
    19: this.montaColuna(null, null, 'moeda'),
    20: this.montaColuna(null, null, 'moeda'),
    25: this.montaColuna(null, null, 'moeda'),
    26: this.montaColuna(null, null, 'moeda'),
    27: this.montaColuna(null, null, 'moeda'),
  }

  requerimentosEstoqueColunasFormatar = [
    { index: 1, tipo: 'protocolo' },
    { index: 6, tipo: 'cnpj' },
    { index: 8, tipo: 'cpf' },
    { index: 14, tipo: 'moeda' },
    { index: 15, tipo: 'moeda' },
    { index: 16, tipo: 'moeda' },
    { index: 19, tipo: 'moeda' },
  ];

  requerimentosEstoqueDataFormatOptions = {
    6: this.montaColuna(null, null, 'cnpj'),
    8: this.montaColuna(null, null, 'cpf'),
    14: this.montaColuna(null, null, 'moeda'),
    15: this.montaColuna(null, null, 'moeda'),
    16: this.montaColuna(null, null, 'moeda'),
    19: this.montaColuna(null, null, 'moeda'),
  }

  requerimentosConcedidosColunasFormatar = [
    { index: 1, tipo: 'protocolo' },
    { index: 6, tipo: 'cnpj' },
    { index: 8, tipo: 'cpf' },
    { index: 14, tipo: 'moeda' },
    { index: 15, tipo: 'moeda' },
    { index: 16, tipo: 'moeda' },
    { index: 17, tipo: 'moeda' },
    { index: 18, tipo: 'moeda' },
    { index: 19, tipo: 'moeda' },
    { index: 20, tipo: 'moeda' },
    { index: 23, tipo: 'moeda' },
    { index: 24, tipo: 'moeda' },
    { index: 25, tipo: 'moeda' },
  ];

  requerimentosConcedidosDataFormatOptions = {
    5: this.montaColuna(null, null, 'cnpj'),
    8: this.montaColuna(null, null, 'cpf'),
    14: this.montaColuna(null, null, 'moeda'),
    15: this.montaColuna(null, null, 'moeda'),
    16: this.montaColuna(null, null, 'moeda'),
    17: this.montaColuna(null, null, 'moeda'),
    18: this.montaColuna(null, null, 'moeda'),
    19: this.montaColuna(null, null, 'moeda'),
    20: this.montaColuna(null, null, 'moeda'),
    23: this.montaColuna(null, null, 'moeda'),
    24: this.montaColuna(null, null, 'moeda'),
    25: this.montaColuna(null, null, 'moeda'),
  }

  requerimentosFluxoColunasFormatar = [
    { index: 1, tipo: 'protocolo' },
    { index: 6, tipo: 'cnpj' },
    { index: 8, tipo: 'cpf' },
    { index: 14, tipo: 'moeda' },
    { index: 15, tipo: 'moeda' },
    { index: 16, tipo: 'moeda' },
    { index: 17, tipo: 'moeda' },
  ];

  requerimentosFluxoDataFormatOptions = {
    6: this.montaColuna(null, null, 'cnpj'),
    8: this.montaColuna(null, null, 'cpf'),
    14: this.montaColuna(null, null, 'moeda'),
    15: this.montaColuna(null, null, 'moeda'),
    16: this.montaColuna(null, null, 'moeda'),
    17: this.montaColuna(null, null, 'moeda'),
  }

  glosaColunasFormatar = [
    { index: 5, tipo: 'cnpj' },
    { index: 7, tipo: 'cpf' },
    { index: 13, tipo: 'moeda' },
  ];

  glosaDataFormatOptions = {
    5: this.montaColuna(null, null, 'cnpj'),
    7: this.montaColuna(null, null, 'cpf'),
    13: this.montaColuna(null, null, 'moeda'),
  }

  glosaEstoqueColunasFormatar = [
    { index: 5, tipo: 'cnpj' },
    { index: 7, tipo: 'cpf' },
    { index: 13, tipo: 'moeda' },
  ];

  glosaEstoqueDataFormatOptions = {
    5: this.montaColuna(null, null, 'cnpj'),
    7: this.montaColuna(null, null, 'cpf'),
    13: this.montaColuna(null, null, 'moeda'),
    15: this.montaColuna('glosa', 'dacao', 'botao'),
  }

  glosaDacaoColunasFormatar = [
    { index: 5, tipo: 'moeda' },
  ];

  glosaDacaoDataFormatOptions = {
    5: this.montaColuna(null, null, 'moeda'),
  }

  bloqueiosColunasFormatar = [
    { index: 4, tipo: 'moeda' },
    { index: 5, tipo: 'motivoBloqueio' },
    { index: 8, tipo: 'moeda' },
  ];

  bloqueiosDataFormatOptions = {
    4: this.montaColuna(null, null, 'moeda'),
    5: this.montaColuna(null, null, 'motivoBloqueio'),
    8: this.montaColuna(null, null, 'moeda'),
  }

  defineContainerStyle = () => {
    let width = this.state.colunasRelatorio.length * 130;
    if (width < 1140) {
      width = 1140;
    }
    return {
      width: `${width}px`,
    };
  };

  render() {
    const options = {
      noDataText: 'Nenhum resultado a ser exibido',
      hideSizePerPage: true,
    };
    return (
      <DtpContentContainer>
        <FiltroRelatorio
          handleSearchFilter={this.handlePesquisar}
          destinatarios={this.props.destinatarios}
          filtroModalidade={false}
          // rgps={this.isRgps()}
          rgps={this.isPapelHabilitadoParaUso()}
          tipo="pagamentos"
        />
        {
          this.state.nomeRelatorio !== '' ? (
            <Relatorio
              legend={this.state.nomeRelatorio}
              bordered
              headers={this.state.colunasRelatorio}
              data={this.state.listaResultados}
              options={options}
              pagination
              dataFormatOptions={this.state.dataFormatOptions}
              landscape
              voltarAction={this.handleVoltar}
              containerStyle={this.defineContainerStyle()}
              exportacao={this.state.listaResultadosFormatados}
            />
          ) : null
        }
      </DtpContentContainer>
    );
  }
}
// eslint-disable-next-line react/prop-types
TelaRelatorioPagamentos.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

TelaRelatorioPagamentos.defaultProps = {
  destinatarios: [],
};

// eslint-disable-next-line
const mapStateToProps = (state) => ({
  destinatarios: state.base.destinatarios,
});

export default connect(mapStateToProps)(TelaRelatorioPagamentos);



// WEBPACK FOOTER //
// ./src/pages/relatorios/TelaRelatorioPagamentos.jsx